import { useParams } from "react-router-dom";
import * as L from "leaflet";

import { PointSourceEmissionDrawOnMap } from "src/components/on-map/PointSourceEmissionDrawOnMap";
import { EmissionOnMap } from "src/components/on-map/EmissionOnMap";
import { EmissionType } from "src/types";
import { EmissionsPage } from "./EmissionsPage";

interface Props {
  map: L.Map;
  controlContainer: Element | null;
}

export function PointSourceEmissionPage(props: Props) {
  const {
    caseId = "",
    scenarioId = "",
    emissionId = "",
    pointSourceId,
  } = useParams<{
    caseId: string;
    scenarioId: string;
    emissionId: string;
    pointSourceId?: string;
  }>();

  return render();

  function render() {
    return (
      <>
        <EmissionsPage map={props.map} />
        <EmissionOnMap {...props} params={{ caseId, scenarioId, emissionId }} type={EmissionType.POINT_SOURCE} />
        <PointSourceEmissionDrawOnMap {...props} params={{ caseId, scenarioId, emissionId, pointSourceId }} />
      </>
    );
  }
}
